// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3KYb6","notes":"Notes_notes__3pHK1","note":"Notes_note__2JEM5","markdown":"Notes_markdown__dmgAe"};